import { Theme, Link } from '@mui/material'
import { makeStyles } from '@mui/styles'

import React from 'react'

interface ILinkComponentProps {
  color?: any
  className?: any
  underline?: 'always' | 'hover' | 'none'
  variant?: | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline' | 'inherit'
  href?: string
  text?: any
  target?: string
  onClick?: () => void
}

export interface ILinkProps {
  color?: any
  underline?: 'always' | 'hover' | 'none'
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline' | 'inherit'
}

export const defaultSettings: ILinkProps = {
  color: 'primary',
  variant: 'inherit',
  underline: 'hover',
}

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    cursor: 'pointer',
  },
}))

const LinkComponent: React.FC<ILinkComponentProps> = (props) => {
  const classes = useStyles()
  const { className, text, href } = props
  const color = props.color ? props.color : defaultSettings.color
  const variant = props.variant ? props.variant : defaultSettings.variant
  const target = props.target ? props.target : ''
  return (
    <Link
      href={href}
      color={color}
      className={`${className} ${classes.link}`}
      variant={variant}
      target={target}
      rel={target !== '' ? 'noopener' : ''}
    >
      {text}
    </Link>
  )
}

export default LinkComponent
